import styled from 'styled-components';

const Center = styled.div`
  display: flex;
  justify-content: center;
`;

export default Center;
